import { IRequest } from '@r1-frontend/shared/types/IRequest';

type TParams = {
    binding_id: number,
    agreement_id: number,
    pay_day?: number,
    required_sum?: number,
}
/*
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/Autopayment/47507f786754ce5301b0cd45f3ad94d8
*
*/

export const activateAutopayment = (
    providerId: number,
    agreement: number,
    bindingCardId: number,
    requiredSum: number | null,
    payDay: number | null,
): IRequest => {

    const params: TParams = {
        binding_id: bindingCardId,
        agreement_id: agreement,
    };
    if (payDay) {
        params.pay_day = payDay;
    }
    if (requiredSum) {
        params.required_sum = requiredSum;
    }

    return {
        uri: '/autopayment/activate',
        withAuth: true,
        withProvider: true,
        method: 'POST',
        body: JSON.stringify({ ...params }),
        queryParams: {
            providerId,
        },
    };
};
